import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { startLoading, endLoading } from '../../../actions/loadingAction';
import { translate, formatData, showMessageToastCustom, isNullOrEmpty, showMessageToast, closeCollapsible, downloadFile } from '../../../utils/util';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import CollapsibleUI from '../../../components/UI/CollapsibleUI';
import { Input, Button, BackButton, Title, SelectResource } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import ScannerCode from '../../../components/UI/ScannerCode';
import { ENUMS } from '../../../utils/constants';
import ChangeLocationService from '../../../services/ChangeLocationService';

const PrintLabelList = (props) => {
    const [receiptStorage, setReceiptStorage] = useState([]);
    const [filter, setFilter] = useState(
        {
            journey: "",
            mvmNumber: "",
            partnumbercode: "",
            cim: "",
            masterCim: "",
            mvi: "",
            truckKanban: props.location?.state?.truckKanban
        });

    useEffect(() => {
        if (props.receiptStorage) {
            setReceiptStorage([...props.receiptStorage])
        }
        // eslint-disable-next-line
    }, [props.receiptStorage]);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const getLabels = () => {
        if (validateInputsRequired("printLabel")) {
            props.showLoading();
            props.getReceiptStorage(
                {
                    ...filter,
                    shed: filter.truckKanban ? "" : props.user.shed,
                    dock: filter.truckKanban ? "" : props.user.dock
                }, (data) => {
                    if (data.length === 0) {
                        showMessageToastCustom(translate('general:warning'), translate('general:no-registry'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    closeCollapsible("filterJourneyMvm")
                    props.hideLoading();
                });
        }
    }

    const downloadReport = (row) => {
        props.getReportLabel({
            Id: row.receiptId,
            transmissionId: row.transmissionId,
            printer: props.user.printer,
            onlyOneLabel: true
        }, (response) => {
            if (response) {
                if (Array.isArray(response)) {
                    response.forEach((element, index) => {
                        downloadFile(element, `Labels${index}-${row.receiptId}.pdf`, "data:application/pdf", true)
                    });
                } else {
                    downloadFile(response, `Labels-${row.receiptId}.pdf`, "data:application/pdf", true)
                }
            }
        });
    }

    const sendPrinter = (row) => {
        if (!props.user.printer) {
            return showMessageToast({ html: translate('select-resource', 'validations'), classes: 'red' });
        }
        if (navigator.userAgent !== 'logisticspwa' && props.user.printer?.connectionType === ENUMS.ePrinterConnectionType.Bluetooth.value) {
            showMessageToastCustom(translate('general:warning'), translate('validations:only-mobile'), 3000, 'mdi mdi-alert-circle-outline red-text');
        }

        if (!isNullOrEmpty(row.changeLocationId)) {
            props.sendToPrintLocation({
                Id: row.changeLocationId,
                printer: props.user.printer,
            });
        } else {
            props.showLoading();
            props.sendToPrint({
                Id: row.receiptId,
                transmissionId: row.transmissionId,
                printer: props.user.printer,
                onlyOneLabel: true
            }, props.user);
        }
    }

    const scanner = (value) => {
        setFilter({
            ...filter,
            ...value
        })
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('physical-confirmation:label-reprint')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <CollapsibleUI
                        id="filterJourneyMvm"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="printLabel" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding  col s5">
                                            <Input
                                                required={isNullOrEmpty(filter?.journey) && isNullOrEmpty(filter?.mvi)}
                                                type="text"
                                                label={translate('physical-confirmation:mvm')}
                                                id="mvmNumber"
                                                name='mvmNumber'
                                                onChange={onChange}
                                                value={filter?.mvmNumber}
                                            />
                                            <ScannerCode onScanner={value => scanner({ mvmNumber: value })} />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                required={isNullOrEmpty(filter?.mvmNumber) && isNullOrEmpty(filter?.mvi)}
                                                type="text"
                                                label={translate('physical-confirmation:journey')}
                                                id="journey"
                                                name='journey'
                                                onChange={onChange}
                                                value={filter?.journey}
                                            />
                                            <ScannerCode onScanner={value => scanner({ journey: value })} />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                type="text"
                                                label="MVI"
                                                id="mvi"
                                                name='mvi'
                                                onChange={onChange}
                                                value={filter?.mvi}
                                            />
                                            <ScannerCode onScanner={value => scanner({ mvi: value })} />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                type="text"
                                                label={translate('physical-confirmation:part-number')}
                                                id="partnumbercode"
                                                name='partnumbercode'
                                                onChange={onChange}
                                                value={filter?.partnumber}
                                            />
                                            <ScannerCode onScanner={value => scanner({ partnumber: value })} />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                type="text"
                                                label={translate('physical-confirmation:cim')}
                                                id="cim"
                                                name='cim'
                                                onChange={onChange}
                                                value={filter?.cim}
                                            />
                                            <ScannerCode onScanner={value => scanner({ cim: value })} />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                type="text"
                                                label="Master CIM"
                                                id="masterCim"
                                                name='masterCim'
                                                onChange={onChange}
                                                value={filter?.masterCim}
                                            />
                                            <ScannerCode onScanner={value => scanner({ masterCim: value })} />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '0px' }}>
                                    <Button full="true" text={translate('general:search')} onClick={() => getLabels()} />
                                </div>
                            </>
                        }
                    />
                </div>
                {receiptStorage.length > 0 &&
                    <>
                        {
                            filter.truckKanban &&
                            <div className="container">
                                <div className="input-field col s12">
                                    <SelectResource
                                        id="resource"
                                        required
                                        name="resource"
                                        value={filter.resource}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        }
                        <ul key={receiptStorage.length} className="collection col s12" style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 0 }}>
                            {receiptStorage.map((item, index) => {
                                return (
                                    <div key={index} className="card" style={{ paddingTop: 0, margin: 0 }}>
                                        <div className="card-content">
                                            <div className="row">
                                                <div className="col s8 black-text">
                                                    <span className="title col s12">{`${item?.partNumberCode}`}</span>
                                                    <span className="title col s12">{`CIM: ${item?.cim || '-'}`}</span>
                                                    <span className="col s12">{item?.partNumberDescription}</span>
                                                    <span className="col s12 m6">{`${translate('physical-confirmation:journey')}: ${item?.journey || '-'}`}</span>
                                                    <span className="col s12 m6">{`${translate('physical-confirmation:mvm')}: ${item?.mvmNumber || '-'}`}</span>
                                                    <span className="col s12 m6">{`${translate('physical-confirmation:almox')}: ${item?.almox || '-'}`}</span>
                                                    <span className="col s12 m6">{`MVI: ${item?.mviId || '-'}`}</span>
                                                    <span className="col s12 m6">{`MDR: ${item?.transmission?.mdr || '-'}`}</span>
                                                    <span className="col s12 m6">{`${translate('physical-confirmation:shed')}: ${item?.shed || '-'}`}</span>
                                                    <span className="col s12 m6">{`${formatData(item?.printedOn) || '-'}`}</span>
                                                    {item?.changeLocationId && <span style={{ color: 'orange' }} className="col s12">Etiqueta Troca Locação (MDR Alternativo)</span>}
                                                </div>
                                                <div className="col s4 center" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <button
                                                        className="btn-floating btn-principal waves-effect waves-light"
                                                        type="button"
                                                        onClick={() => { sendPrinter(item) }}
                                                    >
                                                        <i className="material-icons">local_printshop</i>
                                                    </button>
                                                    <button
                                                        className="btn-floating btn-principal waves-effect waves-light"
                                                        type="button"
                                                        onClick={() => { downloadReport(item) }}
                                                    >
                                                        <i className="material-icons">picture_as_pdf</i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>)
                            })
                            }
                        </ul>
                    </>
                }
            </div>
        </div >
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        physicalConfirmation: state.physicalConfirmationReducer.physicalConfirmation,
        receiptStorage: state.physicalConfirmationReducer.receiptStorage,
        receiptIds: state.physicalConfirmationReducer.receiptIds,
        filter: state.physicalConfirmationReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getReceiptStorage: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getReceiptStorage(filter, callback));
        },
        sendToPrint: (filter, user) => {
            dispatch(PhysicalConfirmationService.sendToPrintInstantConfirmation(filter, user.printer, () => {
                dispatch(endLoading());
            }));
        },
        getReportLabel: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getReportLabelsPdf(filter, callback));
        },
        sendToPrintLocation: (data) => {
            dispatch(ChangeLocationService.reprintLabel(data));
        },
        showLoading: () => {
            dispatch(startLoading());
        },
        hideLoading: () => {
            dispatch(endLoading());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PrintLabelList));


